import React, { useContext, useMemo, useState } from "react";
import { FaUserTie } from "react-icons/fa";
import { useGetStudentDiscountQuery } from "../../../redux/slice/students/studentsDiscount.js";
import EmptyBox from "../../EmptyBox/EmptyBox.jsx";
import Loader from "../../Loader/Loader.jsx";
import { ThemeContext } from "../../context/index.jsx";
import students from "../../../assetss/task_icons/students.jpg"
import { useGetJoinStudentQuery } from "../../../redux/slice/students/JoinStudent.js";
//maneyda import bor ^

const TeacherItem = ({ teacher, index, onStatusChange }) => {
  const { profile } = useContext(ThemeContext);

  return (
    <li className="flex justify-between items-center gap-x-6 px-2 py-3 border   cursor-pointer hover:bg-gray-200">
      <div className="flex min-w-0 gap-x-4">
        <h1>{index + 1}.</h1>
        {teacher?.user?.image && teacher?.user?.image !== "" ? (
          <img
            src={teacher?.user?.image}
            alt="Teacher"
            className="h-12 w-12 flex-none rounded-full border object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full border  flex justify-center items-center">
            <FaUserTie className="text-3xl text-primary" />
          </div>
        )}
        <div className="min-w-0 flex-auto">
          <p className="text-sm font-semibold leading-6">
            {teacher?.user?.first_name}
          </p>
          <p className="mt-1 truncate text-xs leading-5">
            {teacher?.user?.last_name}
          </p>
        </div>

      </div>
      <div className="min-w-0 flex-auto">
          <p className="text-sm font-semibold leading-6">
            {teacher.sinf.name || " "}
          </p>
          <p className="mt-1 truncate text-xs leading-5">
            {teacher.sinf.xona|| 'xona tanlanmagan'}
          </p>
        </div>
      <p className="leading-5">
        {teacher?.user?.username}
      </p>

      <p className="leading-5">
        {teacher?.date_of_admission}
      </p>
   

    </li>
  );
};

function JoinStudent() {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, isLoading, refetch } = useGetJoinStudentQuery();
  const filteredTeachers = useMemo(() => {
    if (searchTerm) {
      return data?.added_students?.filter(
        (teacher) =>
          teacher?.user?.first_name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
          teacher?.user?.last_name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
      );
    } else {
      return data?.added_students;
    }
  }, [data, searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (

    <div className="h-full gap-3 col-span-12">
      <div className="rounded-lg shadow-md col-span-12 grid grid-cols-12 border h-[75vh] items-start overflow-hidden">
        <div className="col-span-12 flex items-center justify-between p-3">
          <div>
            <label htmlFor="table-search" className="sr-only">
              Qidirish
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-white dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="table-search-users"
                className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Izlash..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <h1 className="leading-5 text-white text-xl">Chegirmadagi o'quvchilar soni</h1>
            <img src={students} className="w-12 h-10 object-cover" alt="" />

            <p className="text-4xl">{filteredTeachers?.length}</p>
          </div>
        </div>

        {isLoading ? (
          <Loader extraClass="col-span-12 flex justify-center" Color="#62B238" />
        ) : filteredTeachers?.length > 0 ? (
          <ul className="divide-y-reverse overflow-y-scroll h-[68vh] divide-gray-100 border rounded-lg col-span-12">
            {filteredTeachers?.map((teacher, index) => (
              <TeacherItem teacher={teacher} index={index} key={teacher.id} onStatusChange={refetch} />
            ))}
          </ul>
        ) : (
          <EmptyBox />
        )}
      </div>
    </div>
  );
}

export default JoinStudent;
